
jQuery(document).ready(function() {
	var global_topic = 'All', global_talent = 'All', global_page = 0;
	var filter_count = 0,talent_click = 0, apply = 0,prev_topic = -1;

	setTimeout(function(){jQuery(document).scrollTop(0);},10);
	setTimeout(function(){
		jQuery(document.body).on('touchmove', onScroll); // for mobile
		jQuery(window).on('scroll', onScroll);
		if(jQuery(window).width() >= 768 && jQuery(window).width() <= 993){
			onScroll();
		}
	},1015);
	jQuery.ajax({
		url: '/api/smart_ip/country',
		type: 'GET',
		dataType: 'json',
		async: false,
		success: function(ajaxdata){
			if(ajaxdata['status'] == 200){
				if(ajaxdata['countrycode'] == 'us'){
					jQuery('.footer-container .footer a.ca-notice').addClass('us');
					jQuery('.footer-container .footer a.choice-icon.footer-btn').addClass('us');
				} else {
					jQuery('.footer-container .footer a.cookie-notice').addClass('non-us');
				}
			}
		}
	});
	jQuery(".clear-filter").on("click", function() {
        windowHeight = jQuery(window).height();
	    apply = 0;
		prev_topic =-1;
		headerH = jQuery('header').height();
		filterH = jQuery('.view-filters').height();
		footerH = jQuery('.footer-container').height();
		contentH = windowHeight - (headerH + filterH + footerH) -32;
		jQuery('.row.grid').empty();
		jQuery('.row.grid').append('<div class = "ajax-data"></div>');
		jQuery('.path-videos').find('.grid').css('min-height',(contentH+32)+'px').css('height','0');
		jQuery('.path-videos').find('.ajax-data').css('display','block').css('top','40%');
		talent_click = 1;
		 get_talents();
		if(jQuery(".talent-filter .select-selected").text() != 'ALL TALENT'){
		   jQuery(".talent-filter .select-selected").text('ALL TALENT');
		   jQuery('.talent-filter .select-items a:first').html('ALL TALENT');
		   jQuery('.talent-filter select option:first-child').text('ALL TALENT');
		}

		if(jQuery(".topic-filter .select-selected").text() != 'ALL TOPICS'){
		   jQuery(".topic-filter .select-selected").text('ALL TOPICS');
		   jQuery('.topic-filter .select-items a:first').html('ALL TOPICS');
		   jQuery('.topic-filter select option:first-child').text('ALL TOPICS');
		   jQuery('.topic-filter .select-items a').removeClass('same-as-selected');
		   jQuery('.topic-filter .select-items a:first').addClass('same-as-selected');
		}
		filterTalents('ALL');
		jQuery('.talent-filter .select-items a:first').addClass('same-as-selected');
		setTimeout(function(){
			filter_onclick();
		},400);
		global_topic = 'All';
		global_talent = 'All';
		global_page = 0;
	    filter_count = 0;
		talent_click = 0;
	    scrollFlag = false;
    });
	var windowHeight, headerH, filterH, footerH,contentH;
	jQuery( ".float-md-left" ).on( "click", function() {
		setTimeout(function(){
			filter_onclick();
			apply = 1;
		},400);
	});
	 jQuery(".talent-filter .select-items a").on('click',function(){
		  talent_click = 1;
		  if(jQuery('.talent-filter .select-items a:first').html() != 'ALL TALENT'){
		    jQuery('.talent-filter .select-items a:first').html('ALL TALENT');
		    jQuery('.talent-filter select option:first-child').text('ALL TALENT');
		}
      });
	  jQuery(".talent-filter .select-selected").on('click',function(){
		          if(jQuery('.talent-filter .select-items a:first').html() != 'ALL TALENT'){
		            jQuery('.talent-filter .select-items a:first').html('ALL TALENT');
		            jQuery('.talent-filter select option:first-child').text('ALL TALENT');
		          }
      });

	jQuery(".topic-filter .select-items").click(function(){
		if(apply == 1){
		  prev_topic = global_topic;
		}
		apply = 0;
		var topic = jQuery(".topic-filter .select-selected").text();
		if((topic != "ALL TOPICS") || (topic == "ALL TOPICS" &&  filter_count > 0)){
		  setTimeout(function(){filterTalents(topic);},10);
		  filter_count ++;
		}
      });
	  function escapeFix(name) {
		return name.replace('/&/g', "&amp;").replace('/</g', "&lt;").replace('/>/g', "&gt;").replace('/"/g', "&quot;").replace("/'/g", "&#039;");
	  }
	  function filterTalents(topic){
		if(topic == 'ALL TOPICS'){
		  topic = 'ALL';
		}
		jQuery.ajax({
			url: '/api/filter',
			type: 'GET',
			dataType: 'json',
			async: false,
			data: { topic: topic,domain: 'tmyk1',count: talent_click },
			success: function(ajaxdata){
				if(ajaxdata['status'] == 200){
				var html = escapeFix(ajaxdata['select']);
				html = encodeURI(html);
				jQuery('.talent-filter #edit-field-talent-categories-target-id').html(decodeURI(html)).text();
				  //jQuery('.talent-filter #edit-field-talent-categories-target-id').html(ajaxdata['select'].replace('/&/g', "&amp;").replace('/</g', "&lt;").replace('/>/g', "&gt;").replace('/"/g', "&quot;").replace("/'/g", "&#039;"));
				  get_talents();
				  jQuery('.talent-filter .select-items a').on('click',function(){
				    talent_click =1;
					if(jQuery('.talent-filter .select-items a:first').html() != 'ALL TALENT'){
				      jQuery('.talent-filter .select-items a:first').html('ALL TALENT');
					  jQuery('.talent-filter select option:first-child').text('ALL TALENT');
					}
				  });
				  jQuery(".talent-filter .select-selected").on('click',function(){
		          if(jQuery('.talent-filter .select-items a:first').html() != 'ALL TALENT'){
		            jQuery('.talent-filter .select-items a:first').html('ALL TALENT');
		            jQuery('.talent-filter select option:first-child').text('ALL TALENT');
		          }
                });
			 }
			}
	   });
	}

	jQuery(document).keyup(function(e) {
		if (e.keyCode === 27) {// esc
			tmyk.hidePopup_psaVideo();
		}
	});
	var scrollFlag = false;
	var addition_constant = 0;
	var pressPage = 0, pressScrollFlag = false;
	function onScroll() {
		if (jQuery(".path-videos").length > 0 || jQuery(".path-press").length > 0) {
			var scrollHeight = jQuery(document).height();
			var scrollPosition = jQuery(window).height() + jQuery(window).scrollTop();
			if ((scrollHeight - scrollPosition) <= 200) {
				if (jQuery(".path-videos").length > 0) {
					global_page++;
					if(!scrollFlag){
						loadMoreVideos();
					}
				}
				if (jQuery(".path-press").length > 0) {
					pressPage++;
					if(!pressScrollFlag){
						loadMorePressContent();
					}
				}
			}
		}
	}
	function loadMorePressContent() {
		jQuery.ajax({
			url: '/press?_format=json&page='+pressPage,
			async: false,
			success: function(ajaxdata) {
				if (ajaxdata.length) {
					var html ='';
					jQuery.each(ajaxdata, function(i, val) {
					   html +='<div class="views-row"> <div class="press-row">   <div class="line-divider"></div> <a href="'+val.field_read_more[0].value+'" target="_blank"> <div class="press-link"> <p class="press-sourcev2">'+val.field_source[0].value.toUpperCase()+'</p> <div class="press-content">          <h2 class="press-headlinev2"> '+val.field_press_short_description[0].value.toUpperCase()+'</h2><div class="circle"><p class="press-sourcev3">read<br>more</p> </div></div></div></a></div></div>';
					});
					jQuery('.press-container2').append(html);
				}
				else {
					pressScrollFlag = true;
				}
			}
		});
	}
	function loadMoreVideos(){
		jQuery("#edit-field-topics-target-id option").each(function () {
          if (jQuery(this).html() == jQuery('.topic-filter .select-selected').html()) {
            global_topic = jQuery(this).attr("value");
          }
        });
		jQuery("#edit-field-talent-categories-target-id option").each(function () {
          if (jQuery(this).html() == jQuery('.talent-filter .select-selected').html()) {
            global_talent = jQuery(this).attr("value");
          }
        });
		if(apply == 0){
			global_topic = 'All';
			global_talent = 'All';
		}
		if(prev_topic != -1){
			global_topic = prev_topic;
		}

		jQuery.ajax({
			url: '/videos?_format=json&page='+global_page+'&field_topics_target_id='+global_topic+'&field_talent_categories_target_id='+global_talent,
			async: false,

			success: function(ajaxdata){
				if (ajaxdata.length) {
					var html ='';
					jQuery.each(ajaxdata, function(i, val) {
						var lastname = val.field_last_name;
						if (val.field_last_name == '') { lastname = '&nbsp;';}

					  var img_src = "https://i.ytimg.com/vi/"+val.field_video_id+"/hqdefault.jpg";
					  html +='<div class="picture-item psa_video_container scroll-animation" data-id="'+val.field_video_id+'" data-title="'+val.field_video_id+'" style="width:33.33%"><div class="item-content"><div class="psa_video_header"><p>'+ val.field_topics+'</p></div><div class="video_image"><img class = "hq-default" src="'+img_src+'" width="100%" height="100%" /></div><div class="psa_video_name"><h2>'+val.field_first_name+'<br>'+lastname+'</h2></div></div></div>';
					});
					var data = '<div>'+html+'</div>';
				if(video_Grid_active == 3){
					tmyk.videoGrid_3(true, data);
				}else if(video_Grid_active == 2){
					tmyk.videoGrid_2(true, data);
				}else if(video_Grid_active == 1){
					tmyk.videoGrid_1(true, data);
				}
				jQuery('#page-hidden-value').val(parseInt(jQuery('#page-hidden-value').val()) +1);
				}
				else {
					console.log("Limit Reached");
					scrollFlag = true;
				}
			}
	   });
	}
	function filter_onclick(){
		scrollFlag = false;
		prev_topic = -1;
		global_page = 0;
		jQuery("#edit-field-topics-target-id option").each(function () {
          if (jQuery(this).html() == jQuery('.topic-filter .select-selected').html()) {
            global_topic = jQuery(this).attr("value");
          }
        });
		jQuery("#edit-field-talent-categories-target-id option").each(function () {
          if (jQuery(this).html() == jQuery('.talent-filter .select-selected').html()) {
            global_talent = jQuery(this).attr("value");
          }
        });

		windowHeight = jQuery(window).height();
		headerH = jQuery('header').height();
		filterH = jQuery('.view-filters').height();
		footerH = jQuery('.footer-container').height();
		contentH = windowHeight - (headerH + filterH + footerH) -32;
		jQuery('.row.grid').empty();
		jQuery('.row.grid').append('<div class = "ajax-data"></div>');
		jQuery('.path-videos').find('.grid').css('min-height',(contentH+32)+'px').css('height','0');
		jQuery('.path-videos').find('.ajax-data').css('display','block').css('top','40%');
		jQuery.ajax({
			url: '/videos?_format=json&page='+global_page+'&field_topics_target_id='+global_topic+'&field_talent_categories_target_id='+global_talent,

			success: function(ajaxdata){
				jQuery('.path-videos').find('.ajax-data').css('display','none').css('top','auto');
				if(ajaxdata.length){
				  jQuery('.path-videos').find('.grid').css('min-height','82%').css('min-height','82vh');
				  var html ='';
				  jQuery.each(ajaxdata, function(i, val) {
				    var lastname = val.field_last_name;
					if (val.field_last_name == '') { lastname = '&nbsp;';}
				      var img_src = "https://i.ytimg.com/vi/"+val.field_video_id+"/hqdefault.jpg";
				      html +='<div class="picture-item psa_video_container scroll-animation" data-id="'+val.field_video_id+'" data-title="'+val.field_video_id+'" style="width:33.33%"><div class="item-content"><div class="psa_video_header"><p>'+ val.field_topics+'</p></div><div class="video_image"><img class = "hq-default" src="'+img_src+'" width="100%" height="100%" /></div><div class="psa_video_name"><h2>'+val.field_first_name+'<br>'+lastname+'</h2></div></div></div>';
					});
				  var data = '<div>'+html+'</div>';
				    if(video_Grid_active == 3){
						tmyk.videoGrid_3_load = 1;
						tmyk.videoGrid_3(true, data);
					}else if(video_Grid_active == 2){
						tmyk.videoGrid_2_load = 1;
						tmyk.videoGrid_2(true, data);
					}else if(video_Grid_active == 1){
						tmyk.videoGrid_1_load = 1;
						tmyk.videoGrid_1(true, data);
					}
				jQuery('#page-hidden-value').val(parseInt(jQuery('#page-hidden-value').val()) +1);
				}
				else{
					console.log("no data");
					var noVideoStr = '<p class="noVideo" style="margin-top:'+ ((contentH/2) - 30) +'px">There are no videos available for this topic</p>';
					jQuery('.path-videos').find('.ajax-data').before(noVideoStr);
					jQuery('.path-videos').find('.grid').css('min-height',contentH+'px').css('height','0');
				}
			}
		});
	}
	function get_talents(){
	jQuery('.talent-filter').find('.select-selected').remove();
	jQuery('.talent-filter').find('.select-items').remove();
	var x, i, j, selElmnt, a, b, c;

	x = document.getElementsByClassName("talent-filter");
	for (i = 0; i < x.length; i++) {
	  selElmnt = x[i].getElementsByTagName("select")[0];
	  var idCre = x[i].attributes.name.nodeValue;
	  /* For each element, create a new DIV that will act as the selected item: */
	  a = document.createElement("BUTTON");
	  a.setAttribute("class", "select-selected");
	  a.setAttribute("tabindex", (i+1));
	  a.setAttribute("id", idCre);
	  a.setAttribute("type", 'button');
	  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
	  x[i].appendChild(a);
	  /* For each element, create a new DIV that will contain the option list: */
	  b = document.createElement("DIV");
	  b.setAttribute("class", "select-items select-hide");
	  b.setAttribute("aria-labelledby", idCre);

	  for (j = 0; j < selElmnt.length; j++) {
		/* For each option in the original select element,
		create a new DIV that will act as an option item: */
		c = document.createElement("A");
		c.setAttribute("tabindex", (j+1));
		c.innerHTML = selElmnt.options[j].innerHTML;
		if(selElmnt.options[j].className == 'no-video'){
			c.setAttribute("class", 'no-video-dis');
			c.setAttribute("style", "color:#868686;pointer-events: none;cursor: no-drop;");
		}
		c.addEventListener("click", function(e) {
			/* When an item is clicked, update the original select box,
			and the selected item: */
			var y, i, k, s, h;
			s = this.parentNode.parentNode.getElementsByTagName("select")[0];
			h = this.parentNode.previousSibling;
			for (i = 0; i < s.length; i++) {
			  if (s.options[i].innerHTML == this.innerHTML) {
				s.selectedIndex = i;
				h.innerHTML = this.innerHTML;
				y = this.parentNode.getElementsByClassName("same-as-selected");
				for (k = 0; k < y.length; k++) {
				  y[k].removeAttribute("class");
				}
				this.setAttribute("class", "same-as-selected");
				break;
			  }
			}
			h.click();
		});
		b.appendChild(c);
	  }
	  x[i].appendChild(b);
	  a.addEventListener("click", function(e) {
		/* When the select box is clicked, close any other select boxes,
		and open/close the current select box: */
		focusFlag = true;
		e.stopPropagation();
		closeAllSelect(this);
		this.nextSibling.classList.toggle("select-hide");
		this.classList.toggle("select-arrow-active");
		jQuery('.select-items .same-as-selected').focus();
	  });
	}

}
});

